<template>
  <AdminJobList :hideOwnershipFilters="true" :lockedFilters="{ CustomerIdList: [$route.params.customerId] }">
  </AdminJobList>
</template>


<script>
import AdminJobList from "@/views/job/AdminJobList.vue";

export default {
  name: "CustomerJobs",
  props: {},
  components: {
    AdminJobList,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>